/* famous-db.js — a barra de controle da seção famous-database.

   O trabalho pesado NÃO está aqui. A ordem vem de custom properties que o Liquid grava em cada
   item (--o-fame, --o-year, --o-museum, --o-city, --o-artist, --o-colour) e o CSS aplica com
   `order`; o agrupamento vem de nós de cabeçalho que só aparecem no agrupamento deles. Este
   arquivo só:

     1. mede o header do tema e diz à barra a que altura se prender;
     2. mede a coluna real do masonry e ajusta o span de cada card (o Liquid já pôs um valor
        quase certo, então isto é um ajuste de poucos pixels e não desloca a página) — e, na obra
        ABERTA, calcula o span a partir da altura de verdade do conteúdo dela;
     3. acende os três controles (busca, filtro, agrupamento) — eles nascem `hidden`, porque um
        filtro que não filtra é pior que nenhum — e decide se as vistas Scale e Reader existem
        nesta página, olhando se a caixa de cada uma tem algum elemento dentro;
     4. troca `data-view` e `data-group` no contêiner, que desde o pacote J2 são dois eixos
        independentes: o desenho e a organização;
     5. filtra e busca mexendo em `hidden`, nunca removendo nó do DOM, e mantém os cabeçalhos
        de grupo e o contador em dia;
     6. abre e fecha a FAIXA da metodologia, logo abaixo da barra (pacote N), pelos dois botões
        que a apontam: o "?" da barra e o do hero;
     7. abre e fecha a FICHA DENTRO DO PRÓPRIO ITEM (pacote N). Não há painel, não há nó movido,
        não há requisição: o atributo `data-open` entra no `<li>` e o CSS faz o resto. Desde o J2
        a ficha abre pelo botão "i"; nas obras sem produto o card inteiro também abre;
     8. anima a troca de vista pela técnica FLIP: mede a posição antiga, deixa o CSS assumir a
        nova, aplica a diferença como `transform` e a solta (pacote I1). Abrir e fechar uma obra,
        e abrir e fechar a faixa, passam pelo mesmo caminho — é a lista inteira se reacomodando.

   Sem dependências. Carregado com defer por sections/famous-database.liquid. */
(function () {
  if (window.__famousDb) return;
  window.__famousDb = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function ord(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function plural(n) {
    return n + (n === 1 ? ' painting' : ' paintings');
  }

  ready(function () {
    var root = document.querySelector('[data-famous-db]');
    if (!root) return;
    var grid = root.querySelector('[data-famous-db-grid]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('.famous-db__item'));
    var heads = Array.prototype.slice.call(grid.querySelectorAll('[data-famous-db-head]'));
    var total = items.length;
    if (!total) return;

    var wrap = root.querySelector('[data-famous-db-bar]');
    var counter = root.querySelector('[data-famous-db-count]');
    var qInput = root.querySelector('[data-famous-db-q]');
    var facetSel = root.querySelector('[data-famous-db-facet]');
    var groupSel = root.querySelector('[data-famous-db-group]');

    /* ---------------------------------------- 0. as duas vistas de outro pacote existem?
       O Liquid não sabe perguntar se um snippet está no tema: `render` de um arquivo ausente
       imprime um nó de TEXTO com o erro no lugar dele. Um nó de texto não é `children`, então a
       checagem abaixo separa "o snippet desenhou alguma coisa" de "o snippet não está aqui".
         · Scale sem o snippet do J3 → o botão some de vez. Uma vista que não tem o que desenhar
           é pior do que não ter a vista.
         · Reader sem o snippet do J4 → o botão fica. Desde o pacote N aquela vista é só o estado
           aberto das cem obras, e o desenho da obra aberta está no famous-db.css: sem o arquivo
           do J4 a leitura continua inteira, só não ganha a coluna estreita. */
    var scaleBox = root.querySelector('[data-famous-db-scalebox]');
    var readerBox = root.querySelector('[data-famous-db-readerbox]');
    var scaleBtn = root.querySelector('[data-famous-db-view="scale"]');
    if (scaleBox && scaleBox.children.length) {
      root.setAttribute('data-has-scale', '');
      if (scaleBtn) scaleBtn.hidden = false;
    } else if (scaleBtn && scaleBtn.parentNode) {
      scaleBtn.parentNode.removeChild(scaleBtn);
      scaleBtn = null;
    }
    if (readerBox && readerBox.children.length) root.setAttribute('data-has-reader', '');

    var viewBtns = Array.prototype.slice.call(root.querySelectorAll('[data-famous-db-view]'));

    /* ---------------------------------------------------- 0b. rolar sem rolagem suave
       MEDIDO em 16/09/2026 neste tema: o `<html>` vem com `scroll-behavior: smooth`, então todo
       `window.scrollTo(x, y)` deste arquivo virava uma ANIMAÇÃO de rolagem. Com a obra abrindo
       no lugar isso deu um erro visível: a mira era calculada para o layout de antes, o hero se
       recolhia no meio do caminho (pacote I1, 640px a menos) e a animação terminava 416px depois
       do topo da obra — o visitante clicava na obra 12 e caía no fim da ficha dela.

       Toda rolagem daqui é instantânea. `behavior: 'instant'` é a forma que ignora o CSS; o
       navegador antigo que não conhece a palavra recebe a chamada de sempre. */
    function jumpTo(y) {
      y = Math.max(0, Math.round(y));
      try {
        window.scrollTo({ top: y, left: window.scrollX || 0, behavior: 'instant' });
      } catch (e) {
        window.scrollTo(0, y);
      }
    }

    /* ------------------------------------------------ 1. altura do header do tema
       O tema não expõe nenhuma variável com isso, então o jeito honesto é medir: procura-se um
       header realmente preso (position fixed ou sticky) e usa-se a altura dele. Header que rola
       junto com a página devolve 0, que é o certo. */
    function headerOffset() {
      /* Medido em 15/09/2026 neste tema: o header é o wrapper de grupo de seções
         `div#shopify-section-sections--26006643015977__header`, position sticky, top 0, 167px de
         altura no desktop. O id muda de loja para loja, por isso a busca é por prefixo e sufixo,
         nunca pelo id inteiro. Só conta quem está preso NO TOPO (top <= 1). */
      var sel = '[id^="shopify-section"][id*="header"], #shopify-section-header, .header-wrapper, sticky-header, header.header';
      var cands = document.querySelectorAll(sel);
      var top = 0;
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
        if (parseFloat(cs.top) > 1) continue;
        var h = el.getBoundingClientRect().height;
        if (h > top && h < 240) top = h;
      }
      return Math.round(top);
    }
    function setTop() {
      root.style.setProperty('--db-top', headerOffset() + 'px');
      /* a altura da própria barra: é ela que diz onde a âncora #work-N tem de parar para não
         cair debaixo dos dois controles presos, e de onde a faixa da metodologia desce */
      if (wrap) root.style.setProperty('--db-barh', Math.round(wrap.getBoundingClientRect().height) + 'px');
    }
    setTop();
    /* alguns temas encolhem o header depois do primeiro scroll: uma segunda medida, uma só vez */
    window.addEventListener(
      'scroll',
      function once() {
        window.removeEventListener('scroll', once);
        setTop();
      },
      { passive: true }
    );

    /* ---------------------------------------------------------- 2. span do masonry
       A obra ABERTA (pacote N) atravessa as colunas e cresce até onde o texto pedir. Num masonry
       feito de fileiras de 4px, "até onde o texto pedir" tem de virar um número de fileiras, e
       esse número sai de uma MEDIÇÃO, não da proporção da foto.

       Medir a altura de um item de grade pela própria caixa dele não serve: a caixa é o que a
       fileira manda, e é justamente o que se quer descobrir. Então mede-se o que está dentro —
       a foto e a ficha —, ignorando quem está fora do fluxo (o botão "i" é absoluto) e quem está
       escondido. O `align-content: start` do CSS é o que torna essa conta exata: sem ele as
       faixas se esticariam para preencher a caixa e a medida mediria a si mesma. */
    function openContentHeight(el) {
      var r = el.getBoundingClientRect();
      var cs = getComputedStyle(el);
      var bottom = r.top;
      var kids = el.children;
      for (var i = 0; i < kids.length; i++) {
        var k = kids[i];
        var kcs = getComputedStyle(k);
        if (kcs.display === 'none') continue;
        if (kcs.position === 'absolute' || kcs.position === 'fixed') continue;
        var kr = k.getBoundingClientRect();
        if (kr.bottom > bottom) bottom = kr.bottom;
      }
      return Math.ceil(bottom - r.top + (parseFloat(cs.paddingBottom) || 0));
    }

    var raf = 0;
    function layout() {
      raf = 0;
      if (root.getAttribute('data-view') !== 'cards') return;
      var cs = getComputedStyle(grid);
      var row = parseFloat(cs.gridAutoRows) || 4;
      var gap = parseFloat(cs.rowGap) || 4;
      var tracks = cs.gridTemplateColumns.split(' ').filter(Boolean);
      var cols = tracks.length || 1;
      var colW = parseFloat(tracks[0]);
      if (!colW || isNaN(colW)) colW = (grid.clientWidth - gap * (cols - 1)) / cols;
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        if (el.hidden) continue;
        if (el.hasAttribute('data-open')) {
          el.style.setProperty('--s', Math.max(2, Math.ceil((openContentHeight(el) + gap) / (row + gap))));
          continue;
        }
        var ar = parseFloat(el.getAttribute('data-ar'));
        if (!ar || ar <= 0) ar = 1;
        el.style.setProperty('--s', Math.max(2, Math.round((colW * ar + gap) / (row + gap))));
      }
    }
    function schedule() {
      if (!raf) raf = requestAnimationFrame(layout);
    }
    schedule();
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(grid);
    else window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener(
      'resize',
      function () {
        setTop();
      },
      { passive: true }
    );
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);

    /* ------------------------------------------------------- 2b. O MOVIMENTO (FLIP, I1)
       Trocar de vista não é trocar de tela: são os mesmos cem elementos mudando de lugar. A
       técnica é a clássica — medir onde cada um está, deixar o CSS pôr todos onde vão ficar,
       aplicar a diferença como `transform` e soltar. Só `transform` entra na conta: nada de
       animar top, left ou width, que custaria layout a cada quadro.

       Três travas, porque são cem elementos e não cinco:
         · só entra quem está na tela mais 260px de margem — o resto assume a posição final
           direto, que é o que o brief manda;
         · teto de 60 elementos animados por troca;
         · se a parte síncrona (medir, aplicar) passar de 50ms uma vez, o movimento se desliga
           para o resto da sessão. Um movimento que engasga é pior que nenhum.
       E `prefers-reduced-motion: reduce` desliga tudo: a troca passa a ser imediata. */
    var flipping = [];
    var flipTimer = 0;
    var flipOff = false;
    var mqReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

    function flipCleanup() {
      clearTimeout(flipTimer);
      for (var i = 0; i < flipping.length; i++) {
        flipping[i].removeAttribute('data-flip');
        flipping[i].style.transform = '';
      }
      flipping = [];
    }

    /* `skip` é a obra que está abrindo ou fechando: ela não entra no FLIP. O FLIP move de um
       lugar para outro, e essa obra não está mudando de lugar — está mudando de tamanho. Puxá-la
       de volta para a posição antiga com um transform daria um salto. Quem anima a entrada dela
       é o CSS (famousOpenIn), em seis pixels e uma opacidade. */
    function flip(mutate, skip) {
      if (flipOff || (mqReduce && mqReduce.matches) || !window.requestAnimationFrame) {
        mutate();
        layout();
        return;
      }
      flipCleanup();
      var now = function () {
        return (window.performance && performance.now()) || 0;
      };
      var t0 = now();
      var vh = window.innerHeight;
      var MARGIN = 260;
      var CAP = 60;
      var old = [];
      for (var i = 0; i < items.length && old.length < CAP; i++) {
        var el = items[i];
        if (el.hidden || el === skip) continue;
        var r = el.getBoundingClientRect();
        if (r.bottom < -MARGIN || r.top > vh + MARGIN) continue;
        old.push([el, r.left, r.top]);
      }

      var tMeasure = now() - t0;

      mutate();
      /* o span do masonry entra ANTES de medir a posição nova, senão o FLIP mira num alvo que
         ainda vai se mexer alguns pixels no quadro seguinte */
      layout();

      var t1 = now();
      var moving = [];
      for (var j = 0; j < old.length; j++) {
        var e2 = old[j][0];
        if (e2.hidden) continue;
        var r2 = e2.getBoundingClientRect();
        if (!r2.width && !r2.height) continue;
        var dx = Math.round(old[j][1] - r2.left);
        var dy = Math.round(old[j][2] - r2.top);
        if (!dx && !dy) continue;
        /* um salto de duas telas não é movimento, é teletransporte: assume a posição final */
        if (Math.abs(dy) > vh * 2) continue;
        e2.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0)';
        moving.push(e2);
      }

      /* O custo que conta é o do FLIP: as duas medições e a aplicação das transformações. O que
         `mutate()` e `layout()` gastam acontece com ou sem movimento — trocar de vista custa um
         recálculo de estilo de cem itens de qualquer jeito, e pôr essa conta na cabeça do FLIP
         desligava o movimento logo na primeira troca (medido: 58ms no total, dos quais a parte
         do FLIP era uma fração).

         Teto de 90ms. O número saiu de medição, não de gosto: nesta VM de Codespace a troca
         Gallery→Table custa 34ms no telefone e 41ms no computador, e quase tudo é o layout
         forçado de cem itens — um custo que o navegador pagaria de qualquer jeito ao trocar de
         vista. Um teto de 40ms desligava o movimento logo na primeira troca do computador, ou
         seja media a máquina de teste e não o engasgo. Acima de 90ms (uns cinco quadros só para
         montar a animação) a troca instantânea é de fato melhor, e aí ela fica desligada pelo
         resto da sessão. */
      var cost = tMeasure + (now() - t1);
      root.setAttribute('data-flip-cost', Math.round(cost));
      if (cost > 90) {
        flipOff = true;
        for (var k = 0; k < moving.length; k++) moving[k].style.transform = '';
        return;
      }
      if (!moving.length) return;

      flipping = moving;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          for (var m = 0; m < moving.length; m++) {
            moving[m].setAttribute('data-flip', '');
            moving[m].style.transform = '';
          }
          flipTimer = setTimeout(flipCleanup, 460);
        });
      });
    }

    /* ------------------------------------------------------------ 3. o filtro único
       Um <select> com <optgroup> por faceta, no lugar de duas fileiras de chips. Cabe numa linha,
       funciona no teclado sem código nenhum e no telefone abre a roda nativa do sistema. Os
       valores e as contagens saem dos data-* dos próprios itens — não há segunda fonte. */
    var FACETS = [
      ['artist', 'Artist'],
      ['movement', 'Movement'],
      ['century', 'Century'],
      ['country', 'Country'],
      ['museum', 'Museum']
    ];

    if (facetSel) {
      FACETS.forEach(function (f) {
        var key = f[0];
        var map = new Map();
        items.forEach(function (el) {
          var v = (el.getAttribute('data-' + key) || '').trim();
          if (!v) return;
          map.set(v, (map.get(v) || 0) + 1);
        });
        if (map.size < 2) return;
        var list = Array.from(map.entries()).map(function (e) {
          return { value: e[0], count: e[1], label: key === 'century' ? ord(+e[0]) + ' century' : e[0] };
        });
        list.sort(function (a, b) {
          if (key === 'century') return +a.value - +b.value;
          return b.count - a.count || a.label.localeCompare(b.label);
        });
        var group = document.createElement('optgroup');
        group.label = f[1];
        list.forEach(function (v) {
          var o = document.createElement('option');
          o.value = key + '' + v.value;
          o.textContent = v.label + ' (' + v.count + ')';
          group.appendChild(o);
        });
        facetSel.appendChild(group);
      });
      facetSel.hidden = facetSel.children.length < 2;
    }
    if (qInput) qInput.hidden = false;
    if (groupSel) groupSel.hidden = false;

    /* ------------------------------------------- 4 e 5. estado, filtro, vista, agrupamento */
    var state = { view: 'cards', group: 'fame', userGroup: 'fame', facet: '', value: '', q: '' };

    /* O atributo de cada família de cabeçalho. Os quatro valores saem dos próprios itens: não há
       segunda fonte de verdade em lugar nenhum desta página. */
    var HEAD_ATTR = {
      century: 'data-century',
      city: 'data-city-slug',
      museum: 'data-museum',
      artist: 'data-artist'
    };
    var HEAD_KINDS = ['century', 'city', 'museum', 'artist'];

    /* São 142 cabeçalhos (9 séculos, 28 cidades, 43 museus, 59 artistas e as três caudas) contra
       os 39 de antes. Comparar cada um com os cem itens seriam 14.200 leituras de atributo a cada
       tecla digitada na busca; uma passada só pelos itens, contando os quatro agrupamentos ao
       mesmo tempo, resolve em 400 e o resto é uma volta pelos cabeçalhos. */
    function syncHeads() {
      var counts = {};
      var k;
      for (k = 0; k < HEAD_KINDS.length; k++) counts[HEAD_KINDS[k]] = Object.create(null);
      for (var i = 0; i < items.length; i++) {
        if (items[i].hidden) continue;
        for (k = 0; k < HEAD_KINDS.length; k++) {
          var kind = HEAD_KINDS[k];
          var v = items[i].getAttribute(HEAD_ATTR[kind]) || '';
          counts[kind][v] = (counts[kind][v] || 0) + 1;
        }
      }
      for (var h = 0; h < heads.length; h++) {
        var head = heads[h];
        var hk = head.getAttribute('data-famous-db-head');
        var bag = counts[hk];
        if (!bag) continue;
        var n = bag[head.getAttribute(HEAD_ATTR[hk]) || ''] || 0;
        head.hidden = n === 0;
        var nEl = head.querySelector('[data-famous-db-headn]');
        if (nEl) nEl.textContent = plural(n);
      }
    }

    /* gancho para o painel da ficha: filtrar pode esconder a obra que está aberta */
    var afterApply = null;

    function apply() {
      var shown = 0;
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var ok = true;
        if (state.facet && state.value) {
          ok = (el.getAttribute('data-' + state.facet) || '') === state.value;
        }
        if (ok && state.q) {
          ok = (el.getAttribute('data-q') || '').indexOf(state.q) !== -1;
        }
        el.hidden = !ok;
        if (ok) shown++;
      }
      if (counter) {
        counter.textContent = shown === total ? plural(total) : shown + ' of ' + plural(total);
      }
      syncHeads();
      schedule();
      if (afterApply) afterApply();
    }

    /* preenchido pelo bloco da ficha, mais abaixo. A vista Reader é o estado aberto das cem ao
       mesmo tempo — não é um segundo jeito de mostrar a ficha, é o mesmo `data-open` aplicado à
       lista inteira. Por isso entrar nela abre todas e sair fecha todas, menos a obra que o
       visitante tinha aberto sozinho antes de entrar. */
    var syncReader = null;
    var mapSeen = false;

    function setGroupAttr(g) {
      state.group = g;
      root.setAttribute('data-group', g);
      if (groupSel) groupSel.value = g;
    }

    function setView(view) {
      /* a troca inteira vai dentro do FLIP: o que o visitante vê é a mesma lista mudando de
         forma, e não uma tela sumindo e outra aparecendo */
      flip(function () {
        var from = state.view;
        state.view = view;
        root.setAttribute('data-view', view);
        if (syncReader) syncReader(view, from);
        viewBtns.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-famous-db-view') === view ? 'true' : 'false');
        });
        if (groupSel) {
          /* Scale é o único desenho que não é a lista: quem ordena lá é o snippet do J3, e um
             controle que finge mandar é pior do que um controle desligado. Nas outras quatro o
             agrupamento continua sendo do visitante — a vista Map não impõe mais a cidade em
             silêncio, ela só SUGERE a cidade na primeira vez, e a roda continua aberta. */
          if (view === 'scale') {
            groupSel.disabled = true;
          } else {
            groupSel.disabled = false;
            if (view === 'map' && !mapSeen) {
              mapSeen = true;
              if (state.userGroup === 'fame') {
                state.userGroup = 'city';
                setGroupAttr('city');
              }
            }
          }
        }
        syncHeads();
      });
      schedule();
      /* a barra não pode fugir do topo quando a vista nova é muito mais curta que a anterior */
      requestAnimationFrame(function () {
        if (!wrap) return;
        var off = parseFloat(getComputedStyle(root).getPropertyValue('--db-top')) || 0;
        var r = wrap.getBoundingClientRect();
        if (r.top < off - 1) jumpTo(window.scrollY + r.top - off);
      });
      /* gancho para o pacote E2: um mapa do Leaflet que nasceu num contêiner display:none
         precisa de invalidateSize() quando o contêiner aparece. */
      document.dispatchEvent(new CustomEvent('famous:view', { detail: { view: view } }));
    }

    viewBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        setView(b.getAttribute('data-famous-db-view'));
      });
    });

    if (facetSel) {
      facetSel.addEventListener('change', function () {
        var v = facetSel.value;
        if (!v) {
          state.facet = '';
          state.value = '';
        } else {
          var bits = v.split('');
          state.facet = bits[0];
          state.value = bits[1] || '';
        }
        apply();
      });
    }

    if (groupSel) {
      groupSel.addEventListener('change', function () {
        /* reagrupar é o caso perfeito do FLIP: a mesma lista, os mesmos itens, só o lugar muda */
        flip(function () {
          state.userGroup = groupSel.value;
          setGroupAttr(groupSel.value);
        });
        schedule();
      });
    }

    if (qInput) {
      var t = 0;
      qInput.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          state.q = qInput.value.trim().toLowerCase();
          apply();
        }, 120);
      });
    }

    /* --------------------------------------- 6. A FAIXA DA METODOLOGIA (pacotes H, K1, N)

       Era um popover ancorado ao "?" da barra, e havia um segundo popover no hero que TOMAVA
       EMPRESTADO o texto deste e o devolvia ao fechar. Medido no ar em 16/09/2026: 792 px de
       largura por 48 de altura — a caixa achatada, com o conteúdo sem ter para onde ir.

       Agora é uma faixa de largura inteira logo abaixo da barra, no fluxo da página, que empurra
       a lista para baixo. O texto mora num lugar só (a seção da lista) e os DOIS botões apontam
       para ele: o "?" da barra e o do hero. Nada é emprestado, nada é devolvido.

       O contrato de interação encolheu na mesma medida. Um trecho de página não é uma janela:
       não abre no hover, não fecha no Escape, não fecha no clique fora, não rouba o foco e não
       tem fundo escuro. Abre e fecha no clique (e no Enter e na barra de espaço, de graça num
       <button> de verdade), e é só isso.

       Os dois botões nascem `hidden` e é aqui que eles acendem: sem este arquivo não há faixa
       para abrir, e um botão que não abre nada é pior que nenhum. */
    var howBtns = Array.prototype.slice.call(document.querySelectorAll('[data-famous-db-how], [data-famous-hero-how]'));
    var band = root.querySelector('[data-famous-db-howpanel]');
    if (band && howBtns.length) {
      var bandOpen = function () {
        return !band.hidden;
      };

      howBtns.forEach(function (b) {
        b.hidden = false;
        b.setAttribute('aria-controls', band.id || 'famous-method-panel');
        b.setAttribute('aria-expanded', 'false');
      });

      /* A barra é `position: sticky` e a faixa nasce logo abaixo dela, no fluxo. Quem está lá
         embaixo na obra 60 clica no "?" da barra presa no topo — e a faixa abre a cinco mil
         pixels de distância, onde a lista começa. Então a página vai até ela. Instantâneo de
         propósito: uma rolagem suave ainda estaria correndo quando o visitante já estivesse
         procurando o texto com os olhos. */
      function showBand() {
        var off = parseFloat(getComputedStyle(root).getPropertyValue('--db-top')) || 0;
        var barh = wrap ? wrap.getBoundingClientRect().height : 0;
        var r = band.getBoundingClientRect();
        var want = off + barh;
        if (r.top < want - 1 || r.top > window.innerHeight - 80) jumpTo(window.scrollY + r.top - want);
      }

      function setBand(on) {
        if (on === bandOpen()) return;
        /* a faixa empurra a lista inteira: as obras que estão na tela descem animando, pela
           mesma técnica da troca de vista */
        flip(function () {
          band.hidden = !on;
        });
        schedule();
        howBtns.forEach(function (b) {
          b.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
        if (on) showBand();
      }

      howBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          setBand(!bandOpen());
        });
      });

      /* O hero aponta para #famous-method, que é o invólucro do "?" da barra: chegar com esse
         fragmento abre a faixa em vez de parar numa âncora morta. */
      var bandByHash = function () {
        if (location.hash !== '#famous-method') return;
        setBand(true);
        showBand();
      };
      bandByHash();
      window.addEventListener('hashchange', bandByHash);
    }

    /* ------------------------------------------------- 7. A FICHA ABRE NO LUGAR (pacote N)

       A ficha de cada obra já está no HTML, dentro do `<li>` dela, colapsada por CSS. Abrir uma
       obra é escrever `data-open` nesse `<li>`; fechar é apagá-lo. Não há nó movido, não há
       cópia, não há requisição ao servidor e não há painel: o CSS mostra a ficha, a obra ocupa a
       largura toda e a altura que o texto pedir, e o resto da lista desce.

       O que havia antes era um painel preso na direita, e o motivo de ele ter saído está medido:
       num notebook de 1366×768 ele dava 503 px de altura a uma ficha de 1.761. Rolagem dentro de
       rolagem. Com a ficha no lugar, quem rola é a página.

       O endereço ganha #work-N por replaceState — sem entrada nova no histórico e sem o salto que
       location.hash provocaria. Chegar na página com o fragmento já abre a obra certa, e agora o
       fragmento aponta para um elemento que está mesmo na página.

       Os botões de obra anterior e seguinte saíram: com a ficha aberta na grade, a obra seguinte
       está logo abaixo. */
    var openLi = null;
    /* a obra que o visitante abriu sozinho, para ela sobreviver a uma ida e volta à vista de
       leitura (que abre as cem) */
    var soloLi = null;
    var detailRO = null;

    /* o botão "i" é o único controle que anuncia o estado, e ele existe nas cem obras */
    function triggerOf(li) {
      return li.querySelector('[data-famous-db-info]');
    }

    function markOpen(li, on) {
      if (on) li.setAttribute('data-open', '');
      else li.removeAttribute('data-open');
      var t = triggerOf(li);
      if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    function setHash(id) {
      if (!window.history || !history.replaceState) return;
      try {
        history.replaceState(null, '', location.pathname + location.search + '#' + id);
      } catch (e) {}
    }
    function clearHash() {
      if (!window.history || !history.replaceState) return;
      if (!/^#work-\d+$/.test(location.hash)) return;
      try {
        history.replaceState(null, '', location.pathname + location.search);
      } catch (e) {}
    }

    function byRank(n) {
      return grid.querySelector('.famous-db__item[data-rank="' + String(n).replace(/[^0-9]/g, '') + '"]');
    }

    function num(name, fallback) {
      var v = parseFloat(getComputedStyle(root).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    }

    /* Abrir muda a altura de tudo o que vem depois, e no masonry a obra aberta ainda atravessa as
       colunas e desce para a primeira fileira livre — ela pode acabar longe de onde foi clicada.
       Então a página mira o topo da obra logo abaixo da barra, mas só quando ele não está numa
       posição confortável: rolar quando já está bom é tirar o chão de quem não pediu nada. */
    function bringIntoView(li) {
      var top = num('--db-top', 0) + num('--db-barh', 52) + 12;
      var r = li.getBoundingClientRect();
      if (r.top < top || r.top > top + 260) jumpTo(window.scrollY + r.top - top);
    }

    /* A altura da ficha muda depois de aberta: a procedência é um <details> que o visitante
       abre, a fonte do tema pode chegar atrasada, a janela muda de largura. No masonry isso tem
       de virar um número de fileiras novo, senão a obra seguinte encavala. Um observador na
       própria ficha resolve os três casos de uma vez. */
    if (window.ResizeObserver) {
      detailRO = new ResizeObserver(function () {
        schedule();
      });
    }
    function watchDetail(li, on) {
      if (!detailRO) return;
      var d = li.querySelector('[data-famous-db-detail]');
      if (!d) return;
      if (on) detailRO.observe(d);
      else detailRO.unobserve(d);
    }

    function openWork(li, fromHash) {
      if (!li) return;
      /* na vista de leitura as cem já estão abertas: "abrir a obra" é levar o visitante até ela */
      if (state.view === 'reader') {
        soloLi = li;
        bringIntoView(li);
        setHash('work-' + li.getAttribute('data-rank'));
        return;
      }
      if (openLi === li) return;
      var prev = openLi;
      flip(function () {
        if (prev) {
          markOpen(prev, false);
          watchDetail(prev, false);
        }
        markOpen(li, true);
      }, li);
      openLi = li;
      soloLi = li;
      watchDetail(li, true);
      schedule();
      setHash('work-' + li.getAttribute('data-rank'));
      /* Três miras, e cada uma tem uma razão medida:
           · a de agora leva a obra para debaixo da barra;
           · a do quadro seguinte corrige o span, que só é escrito depois que o layout() roda;
           · a de 200 ms é o hero. Na PRIMEIRA rolagem da página ele se recolhe (pacote I1) e
             leva 640px do topo embora; a âncora de rolagem do navegador segura a página, mas o
             ajuste chega depois deste quadro. Sem esta terceira mira, a primeira obra aberta de
             cada sessão parava fora de lugar.
         Todas passam pelo mesmo `if` do bringIntoView: se a obra já está confortável, ninguém
         mexe na página. */
      bringIntoView(li);
      requestAnimationFrame(function () {
        if (openLi === li) bringIntoView(li);
      });
      window.setTimeout(function () {
        if (openLi === li) bringIntoView(li);
      }, 200);
      document.dispatchEvent(new CustomEvent('famous:view', { detail: { view: state.view } }));
    }

    function closeWork(giveFocus) {
      if (!openLi) return;
      var back = openLi;
      flip(function () {
        markOpen(back, false);
      }, back);
      watchDetail(back, false);
      openLi = null;
      soloLi = null;
      schedule();
      clearHash();
      if (giveFocus) {
        var t = triggerOf(back) || back;
        try {
          t.focus({ preventScroll: true });
        } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('famous:view', { detail: { view: state.view } }));
    }

    /* ---- O CLIQUE DO CARD (pacote J2, com a trava do N)
       Duas regras, e nada entre elas:
         · obra COM produto vendável — a imagem e o título são o link do produto, e o único
           caminho para a ficha é o botão "i". Aqui não se intercepta nada: o `<a>` faz o que um
           `<a>` faz, inclusive com o botão do meio, com Ctrl e com "abrir em nova aba".
         · obra SEM produto — não há destino comercial, então o card inteiro abre a ficha.
       Links que levam para FORA (museu, Wikipedia, Commons) continuam funcionando em ambas.

       A TRAVA: com a obra ABERTA o card não fecha nada. Fechar ao clicar num parágrafo impediria
       até selecionar o texto. Quem fecha é o botão "i", que virou o "×". */
    grid.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var li = e.target.closest('.famous-db__item');
      if (!li) return;

      if (e.target.closest('[data-famous-db-info]')) {
        e.preventDefault();
        if (li.hasAttribute('data-open')) closeWork(true);
        else openWork(li, false);
        return;
      }
      /* o botão de revelar imagem explícita é do famous.js */
      if (e.target.closest('[data-famous-reveal]')) return;
      /* na vista de leitura a ficha já está na tela: nada do card é interceptado, senão a
         seleção de texto e os links de dentro da ficha ficariam presos */
      if (state.view === 'reader') return;
      if (li.hasAttribute('data-open')) return;

      var a = e.target.closest('a');
      if (a && !a.classList.contains('famous-db__title')) return;
      if (li.hasAttribute('data-buy')) return;
      e.preventDefault();
      openWork(li, false);
    });

    /* Escape fecha a obra aberta e devolve o foco ao botão que a abriu. Não é um diálogo, então
       o Escape aqui é cortesia de teclado, e não obrigação de foco preso. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      if (!openLi) return;
      closeWork(true);
    });

    /* ---- o fragmento: chegar com #work-12 abre a obra 12, e mudar o fragmento à mão também */
    function openFromHash(initial) {
      var m = /^#work-(\d+)$/.exec(location.hash || '');
      if (!m) {
        if (!initial && openLi && !location.hash) closeWork(false);
        return;
      }
      var li = byRank(m[1]);
      if (!li) return;
      openWork(li, true);
    }
    window.addEventListener('hashchange', function () {
      openFromHash(false);
    });
    openFromHash(true);
    /* as imagens do grid chegam depois do DOMContentLoaded e empurram a lista para baixo; uma
       segunda mira, uma só vez, põe a obra do fragmento de volta no lugar certo */
    if (/^#work-\d+$/.test(location.hash || '')) {
      window.addEventListener('load', function () {
        if (openLi) bringIntoView(openLi);
      });
    }

    /* filtrar pode esconder a obra aberta; a lista não fica mostrando o texto do que saiu dela */
    afterApply = function () {
      if (openLi && openLi.hidden) closeWork(false);
    };

    /* ---- A VISTA DE LEITURA É O ESTADO ABERTO DAS CEM (decisão do item 3 do brief N)
       Ela não ganhou um segundo mecanismo: é o mesmo `data-open`, na lista inteira. Entrar abre
       todas; sair fecha todas e devolve a obra que o visitante tinha aberto sozinho, se havia. */
    syncReader = function (view, from) {
      if (view === 'reader') {
        for (var i = 0; i < items.length; i++) markOpen(items[i], true);
        if (openLi) watchDetail(openLi, false);
        /* na leitura não existe "a obra aberta": existem as cem */
        openLi = null;
        return;
      }
      if (from !== 'reader') return;
      for (var j = 0; j < items.length; j++) {
        if (items[j] !== soloLi) markOpen(items[j], false);
      }
      if (soloLi) {
        markOpen(soloLi, true);
        openLi = soloLi;
        watchDetail(soloLi, true);
      }
    };

    syncHeads();
  });
})();
